import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  display: flex;
  position: relative;
`;

export const MainContent = styled.div`
  background-color: #fff;
  padding: 24px 34px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  color: #000;
`;
